/**
 * MAX_FLOCK_INSTANCES lives in its own module so non-Babylon consumers (the
 * story queue, tests) can read the constant without dragging babylonjs in.
 * FlockManager.ts re-exports it as the canonical public name.
 *
 * Fixed at 500 — the launch flock size. (This previously defaulted to 1000 with
 * a `?flock=N` on-device override for performance testing; the override and its
 * parsing were removed once 500 was locked in.) The effective bird count is
 * still `min(Flock.glb slot count, MAX_FLOCK_INSTANCES)` — see
 * FlockManager.createInstances.
 */
export const MAX_FLOCK_INSTANCES = 500;
